'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var Dom = require('react-dom');
var _ = require('underscore');
var GlobalConst = require('../../types/GlobalConst');


var HorizontalScrollBar = React.createClass({
  propTypes: {
    value: React.PropTypes.number.isRequired,
    left: React.PropTypes.number,
    top: React.PropTypes.number,
    right: React.PropTypes.number,
    bottom: React.PropTypes.number,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    backgroundColor: React.PropTypes.string,
    zIndex: React.PropTypes.number
  },

  componentDidUpdate: function () {
    this.repaint();
  },

  componentDidMount: function () {
    this.repaint();
  },

  repaint: function () {
    var selfDom = Dom.findDOMNode(this);
    var clientHeight = selfDom.clientHeight;
    var clientWidth = selfDom.clientWidth;
    var contentDom = Dom.findDOMNode(this.refs.content);

    var barWidth;
    var actualProgress;
    var length1 = 59;
    var length2 = 21;
    var contentStyle;

    barWidth = (clientWidth * length2) / length1;
    if (this.props.value == 100) {
      actualProgress = clientWidth - barWidth - 13;
    } else {
      actualProgress = (clientWidth - 30 - barWidth) * (this.props.value / 100) + 15;
    }

    contentStyle = {
      top: '1px',
      left: Math.round(actualProgress - 1) + 'px',
      width: Math.round(barWidth) + 'px',
      height: parseInt(clientHeight - 2, 10) + 'px'
    };

    contentDom.style.left = contentStyle.left;
    contentDom.style.top = contentStyle.top;
    contentDom.style.width = contentStyle.width;
    contentDom.style.height = contentStyle.height;
  },

  render: function () {
    var style;
    var leftBarStyle;
    var rightBarStyle;
    var contentStyle;

    style = {
      position: 'absolute',
      left: this.props.left || '0px',
      //top: this.props.top || '0px',
      bottom: this.props.bottom || '0px',
      right: this.props.right || '0px',
      width: this.props.width ? this.props.width + 'px' : '100%',
      height: this.props.height ? this.props.height + 'px' : '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      backgroundColor: this.props.backgroundColor || GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR,
      zIndex: this.props.zIndex || undefined
    };

    leftBarStyle = {
      position: 'absolute',
      left: '-1px',
      top: '-1px',
      height: this.props.height || '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    rightBarStyle = {
      position: 'absolute',
      right: '-1px',
      top: '-1px',
      height: this.props.height || '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    contentStyle = {
      position: 'absolute',
      top: '2px',
      left: '0px',
      width: '0px',
      height: '0px',
      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      border: 'none'
    };

    return (<div style={style}>
      <img style={leftBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-left.png')}/>
      <img style={rightBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-right.png')}/>
      <div ref="content" style={contentStyle}/>
    </div>);
  }
});

module.exports = HorizontalScrollBar;



// WEBPACK FOOTER //
// ./src/views/common/HorizontalScrollBar.jsx